/** Small helpers shared inside world-package/ (this folder is copied whole into the kit). */
export const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
export const problem = (path, message) => ({ path, message });
/** Control characters and bidi overrides/isolates: never in a name or text a teacher or maker reads. */
// eslint-disable-next-line no-control-regex
export const UNSAFE_TEXT = /[\u0000-\u001f\u007f-\u009f؜‎‏‪-‮⁦-⁩]/;
/** An input as a message echoes it: JSON or the string itself, controls replaced, at most 80 characters. */
export function show(value) {
    let text;
    try {
        text = typeof value === 'string' ? value : (JSON.stringify(value) ?? typeof value);
    }
    catch {
        text = typeof value;
    }
    // eslint-disable-next-line no-control-regex
    text = text.replace(/[\u0000-\u001f\u007f-\u009f؜‎‏‪-‮⁦-⁩]/g, '?');
    return text.length > 80 ? `${text.slice(0, 77)}...` : text;
}
/** A lookup in a table keyed by names a maker chose: own entries only (`constructor` is nothing). */
export function lookup(table, key) {
    return typeof key === 'string' && Object.hasOwn(table, key) ? table[key] : undefined;
}
export const dutch = (n) => String(n).replace('.', ',');
/** A number of metres as a world maker reads it: 4.5 → "4,5". */
export const metres = (n) => String(n).replace('.', ',');
export const COLOUR = /^#[0-9a-f]{6}$/;
export const MESH = /^[a-z0-9][a-z0-9_-]{0,39}$/;
export const ID = /^[a-z][a-z0-9-]{0,23}$/;
export const isNumber = (value) => typeof value === 'number' && Number.isFinite(value);
/** Whether (x, z) is inside the polygon (ray casting; a point on an edge may go either way). */
export function insidePolygon(points, x, z) {
    let hit = false;
    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
        const [xi, zi] = points[i];
        const [xj, zj] = points[j];
        if (zi > z !== zj > z && x < ((xj - xi) * (z - zi)) / (zj - zi) + xi)
            hit = !hit;
    }
    return hit;
}
//# sourceMappingURL=util.js.map